import { ETaxonomy } from "library/types";
import { useMemo } from "react";
import { useTaxonomyOptions } from "./useTaxonomyOptions";
import { useGetCurrencyRates } from "state/queries/useGetCurrencyRates";

export function useCurrencyRates() {
  const {data: currencyRateList ,isLoading} = useGetCurrencyRates()
  
  const currencyOptions = useTaxonomyOptions(ETaxonomy.Currency);

  const currencyRatesPerCountries = useMemo(() => {
    let result = {};
    if (!currencyOptions || !currencyRateList) return result;

    const euro = currencyOptions.find((option) => option.codeShort === "EUR");

    currencyOptions.forEach((option) => {
      if (currencyRateList[option.codeShort]) {
        result[option.value] = {
          ...option,
          rate: currencyRateList[option.codeShort],
        };
      }
    });

    if (euro) {
      result[euro.value] = {
        ...euro,
        rate: 1,
      };
    }

    return result;
  }, [currencyOptions, currencyRateList]);
  
  return {
    currencyRatesPerCountries,
    currencyRatesLoading:
      isLoading || Object.keys(currencyRatesPerCountries).length === 0,
  };
}
